module.exports = __webpack_public_path__ + "bm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bm.svg
// module id = 710
// module chunks = 0